import React, { useContext } from 'react';
import { ThemeContext, FirebaseContext } from '../App'; // Import contexts
import './Header.css';

function Header({ userXUsername }) { // Receive userXUsername as a prop
    // Access theme, toggleTheme, navigateTo, and currentView from ThemeContext
    const { theme, toggleTheme, navigateTo, currentView } = useContext(ThemeContext);
    // Access userId from FirebaseContext
    const { userId } = useContext(FirebaseContext);

    // Function to get unavatar.io URL for X username
    const getPfpUrl = (username) => {
        if (!username) return `https://placehold.co/32x32/cccccc/333333?text=PFP`; // Fallback placeholder
        return `https://unavatar.io/x/${username}`;
    };

    return (
        <header className="app-header">
            <div className="header-content">
                <h1 className="app-title">Succinct Games & Video Edits</h1>
                <div className="header-right">
                    {/* Navigation Buttons */}
                    <nav className="main-nav">
                        <button
                            className={`nav-button ${currentView === 'browse' ? 'active' : ''}`}
                            onClick={() => navigateTo('browse')}
                        >
                            Browse Games
                        </button>
                        <button
                            className={`nav-button ${currentView === 'upload' ? 'active' : ''}`}
                            onClick={() => navigateTo('upload')}
                        >
                            Upload Game
                        </button>
                    </nav>

                    {/* Display User ID and PFP */}
                    {userId && (
                        <span className="user-id-display">
                            {userXUsername && (
                                <img
                                    src={getPfpUrl(userXUsername)}
                                    alt={`${userXUsername}'s profile`}
                                    className="user-pfp"
                                    onError={(e) => { e.target.onerror = null; e.target.src = `https://placehold.co/32x32/cccccc/333333?text=PFP`; }}
                                />
                            )}
                            {userXUsername ? `${userXUsername}` : `User ID: ${userId.substring(0, 8)}...`}
                        </span>
                    )}
                    <button onClick={toggleTheme} className="theme-toggle-button">
                        {/* Use Font Awesome icons based on current theme */}
                        {theme === 'light' ? (
                            <i className="fas fa-moon"></i> // Moon icon for light mode (click to go to dark)
                        ) : (
                            <i className="fas fa-sun"></i> // Sun icon for dark mode (click to go to light)
                        )}
                        {theme === 'light' ? 'Dark Mode' : 'Light Mode'}
                    </button>
                </div>
            </div>
        </header>
    );
}

export default Header;
